/*
  Bonny & Rose: meer stuks, meer korting.

  De kiezer boven de bestelknop bepaalt hoeveel stuks er in één keer meegaan.
  Stuk 1 is wat er boven op de pagina staat; voor stuk 2 en verder komt er per
  stuk een regel bij met een eigen kleur en maat, met de foto van die kleur
  ernaast. Elke kleur is een eigen product, dus meerdere kleuren betekent hier
  meerdere producten in dezelfde bestelling.

  De korting wordt niet meegestuurd. Shopify past hem zelf toe zodra het aantal
  in de winkelwagen staat. Wat hier wél gerekend wordt is het bedrag dat op de
  bestelknop komt te staan: de prijzen van de gekozen stuks bij elkaar, min het
  percentage van de gekozen trap. De prijzen komen uit Liquid en staan dus al in
  de munt van de bezoeker.

  Twee dingen zijn bewust zo geregeld:
  1. Het versturen wordt afgevangen in de vangfase op de pagina zelf, vóór het
     thema erbij kan. Anders stuurt het thema alleen stuk 1 door.
  2. Na het toevoegen gaat hetzelfde bericht uit als het thema zelf stuurt, zodat
     de winkelwagenlade zichzelf opnieuw opbouwt en opengaat.
*/
(function () {
  'use strict';

  /* Wat de kiezer aanwijst zodra de pagina opent. Dit staat bewust op één stuk:
     op twee begint de pagina met een extra regel met keuzelijsten die de
     bezoeker niet gevraagd heeft, en zegt de bestelknop dat ze er twee koopt.
     Nu opent alles rustig en gebeurt er pas iets als zij het aanwijst. */
  var STANDAARD = 1;
  var KORTING = { 1: 0, 2: 10, 3: 15, 4: 20, 5: 25 };
  var gekozen = STANDAARD;

  function blok() { return document.querySelector('[data-br-bundle]'); }

  function hoofd() {
    return document.querySelector('[id^="shopify-section-"][id$="__main"]') || document;
  }

  function knop() {
    var lijst = hoofd().querySelectorAll('button[name="add"], .add-to-cart');
    for (var i = 0; i < lijst.length; i++) {
      /* de knop in de vaste balk onderaan telt niet mee: die klikt de echte aan */
      if (!lijst[i].closest('[data-br-sticky]')) return lijst[i];
    }
    return null;
  }

  function vorm() {
    var k = knop();
    return k ? k.closest('form') : null;
  }

  function gegevens() {
    var b = blok();
    if (!b) return null;
    var s = b.querySelector('[data-br-bundle-data]');
    if (!s) return null;
    try {
      var d = JSON.parse(s.textContent);
      return (d && d.colors && d.colors.length) ? d : null;
    } catch (e) {
      return null;
    }
  }

  /* De maat die nu op de pagina gekozen staat, zodat een tweede stuk daar
     standaard op begint. Wie twee keer dezelfde jurk wil, hoeft dan niets. */
  function huidigeMaat(d) {
    var f = vorm();
    var veld = f && f.querySelector('[name="id"]');
    if (!veld || !veld.value) return null;
    var v = uitvoering(d, veld.value);
    return v ? v.s : null;
  }

  function uitvoering(d, id) {
    id = String(id);
    for (var i = 0; i < d.colors.length; i++) {
      for (var j = 0; j < d.colors[i].v.length; j++) {
        if (String(d.colors[i].v[j].id) === id) return d.colors[i].v[j];
      }
    }
    return null;
  }

  /* De maten van klein naar groot. Staat er iets tussen dat geen maat is, dan
     blijft de lijst precies zoals hij was. */
  var LADDER = ['xs', 's', 'm', 'l', 'xl', '2xl', '3xl', '4xl', '5xl', '6xl'];
  function opMaat(lijst) {
    var kopie = lijst.slice();
    for (var i = 0; i < kopie.length; i++) {
      if (LADDER.indexOf(String(kopie[i].s).trim().toLowerCase()) < 0) return lijst;
    }
    return kopie.sort(function (a, b) {
      return LADDER.indexOf(String(a.s).trim().toLowerCase()) -
             LADDER.indexOf(String(b.s).trim().toLowerCase());
    });
  }

  /* Een model zonder maten heeft in Shopify één uitvoering die "Default Title"
     heet. Daar valt niets te kiezen, dus dan komt er geen maatlijst. */
  function zonderMaten(kleur) {
    return kleur.v.length === 1 && /^default title$/i.test(kleur.v[0].s);
  }

  function veld(labelTekst) {
    var houder = document.createElement('div');
    houder.className = 'br-slot__veld';
    var lab = document.createElement('span');
    lab.className = 'br-slot__mini';
    lab.textContent = labelTekst;
    houder.appendChild(lab);
    var sel = document.createElement('select');
    sel.className = 'br-slot__sel';
    sel.setAttribute('aria-label', labelTekst.replace(':', ''));
    houder.appendChild(sel);
    return { houder: houder, sel: sel };
  }

  function maakSlot(nr, d, maatWens) {
    var wrap = document.createElement('div');
    wrap.className = 'br-slot';

    var lab = document.createElement('div');
    lab.className = 'br-slot__lab';
    lab.textContent = 'Item ' + nr;
    wrap.appendChild(lab);

    var rij = document.createElement('div');
    rij.className = 'br-slot__row';
    wrap.appendChild(rij);

    /* De foto van de gekozen kleur, links van de keuze. Zonder foto blijft er
       een leeg vakje in dezelfde kleur staan, zodat de rij niet verspringt. */
    var foto = document.createElement('img');
    foto.className = 'br-slot__foto';
    foto.setAttribute('alt', '');
    foto.setAttribute('loading', 'lazy');
    foto.width = 52;
    foto.height = 66;
    rij.appendChild(foto);

    var kleurVeld = veld('Color:');
    var kleurSel = kleurVeld.sel;
    for (var i = 0; i < d.colors.length; i++) {
      var ok = document.createElement('option');
      ok.value = String(i);
      ok.textContent = d.colors[i].n;
      kleurSel.appendChild(ok);
      if (d.colors[i].h === d.self) kleurSel.value = String(i);
    }
    rij.appendChild(kleurVeld.houder);

    var maatVeld = veld('Size:');
    var maatSel = maatVeld.sel;
    rij.appendChild(maatVeld.houder);

    function huidigeKleur() {
      return d.colors[parseInt(kleurSel.value, 10)] || d.colors[0];
    }

    function vulMaten(wens) {
      var c = huidigeKleur();
      maatSel.innerHTML = '';
      maatVeld.houder.hidden = zonderMaten(c);
      /* Shopify zet een later toegevoegde maat achteraan; hier hoort hij op zijn
         eigen plek in de reeks te staan, net als bij de maatknoppen. */
      var lijst = opMaat(c.v);
      for (var i = 0; i < lijst.length; i++) {
        var o = document.createElement('option');
        o.value = String(lijst[i].id);
        o.textContent = lijst[i].s;
        maatSel.appendChild(o);
        if (wens && lijst[i].s === wens) maatSel.value = String(lijst[i].id);
      }
      if (c.i) {
        foto.src = c.i;
        foto.hidden = false;
      } else {
        foto.removeAttribute('src');
        foto.hidden = true;
      }
    }

    /* Bij een andere kleur blijft dezelfde maat staan als die kleur hem heeft.
       Heeft hij hem niet, dan valt de lijst terug op de eerste maat. */
    kleurSel.addEventListener('change', function () {
      var nu = maatSel.options[maatSel.selectedIndex];
      vulMaten(nu ? nu.textContent : maatWens);
      werkBedragBij();
    });

    /* Zolang de bezoeker hier zelf geen maat heeft gekozen, volgt dit stuk de
       maat die boven op de pagina aanstaat. Kiest ze daar M, dan staat stuk 2
       ook op M. Raakt ze dit lijstje aan, dan blijft haar keuze staan. */
    var geraakt = false;
    maatSel.addEventListener('change', function () {
      geraakt = true;
      werkBedragBij();
    });
    wrap.brVolgMaat = function (maat) {
      if (geraakt || !maat) return;
      var nu = maatSel.options[maatSel.selectedIndex];
      if (nu && nu.textContent === maat) return;
      vulMaten(maat);
    };

    vulMaten(maatWens);
    wrap.brVariant = function () { return maatSel.value || null; };
    return wrap;
  }

  function fout(tekst) {
    var b = blok();
    var p = b && b.querySelector('[data-br-bundle-err]');
    if (!p) return;
    p.textContent = tekst || '';
    p.hidden = !tekst;
  }

  /* Wat deze bestelling kost: de gekozen stuks bij elkaar, min het percentage
     van de gekozen trap. In centen, want de knop maakt er zelf een bedrag van
     met de munt van het land erbij. */
  function bedragInCenten(d) {
    var f = vorm();
    var veldId = f && f.querySelector('[name="id"]');
    if (!veldId || !veldId.value) return 0;

    var eerste = uitvoering(d, veldId.value);
    if (!eerste) return 0;
    var som = eerste.p || 0;

    var slots = blok().querySelectorAll('.br-slot');
    for (var i = 0; i < slots.length; i++) {
      var id = slots[i].brVariant && slots[i].brVariant();
      var v = id ? uitvoering(d, id) : null;
      if (!v) return 0;
      som += v.p || 0;
    }
    return Math.round(som * (100 - (KORTING[gekozen] || 0)) / 100);
  }

  function werkBedragBij() {
    var f = vorm();
    var d = gegevens();
    if (!f || !d) return;
    f.setAttribute('data-br-qty', String(gekozen));
    f.setAttribute('data-br-cents', String(gekozen > 1 ? bedragInCenten(d) : 0));
    document.dispatchEvent(new CustomEvent('br:qty'));
  }

  function teken() {
    var b = blok();
    var d = gegevens();
    if (!b || !d) return;
    b.hidden = false;

    var knoppen = b.querySelectorAll('[data-br-tier]');
    for (var i = 0; i < knoppen.length; i++) {
      var aan = knoppen[i].getAttribute('data-br-tier') === String(gekozen);
      knoppen[i].classList.toggle('is-active', aan);
      knoppen[i].setAttribute('aria-checked', aan ? 'true' : 'false');
    }

    var host = b.querySelector('[data-br-slots]');
    host.innerHTML = '';
    host.hidden = gekozen < 2;
    var maat = huidigeMaat(d);
    for (var n = 2; n <= gekozen; n++) host.appendChild(maakSlot(n, d, maat));

    fout('');
    werkBedragBij();
  }

  function voegToe(f, items) {
    var k = knop();
    if (k) k.classList.add('btn--loading');
    fout('');

    fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (k) k.classList.remove('btn--loading');
        if (data && data.status && data.status !== 200) {
          fout(data.description || data.message || 'Something went wrong. Please try again.');
          return;
        }
        if (window.theme && theme.settings && theme.settings.cartType === 'page') {
          window.location = (theme.routes && theme.routes.cartPage) || '/cart';
          return;
        }
        f.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: data, addToCartBtn: k },
          bubbles: true
        }));
      })
      .catch(function () {
        if (k) k.classList.remove('btn--loading');
        fout('Something went wrong. Please try again.');
      });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-br-tier]');
    if (!t) return;
    e.preventDefault();
    gekozen = parseInt(t.getAttribute('data-br-tier'), 10) || 1;
    teken();
  });

  /* Een andere maat op de pagina zelf neemt de stuks eronder mee en verandert
     ook het bedrag op de knop. */
  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    var maat = v && (v.option1 || v.title);
    var b = blok();
    if (maat && b) {
      var slots = b.querySelectorAll('.br-slot');
      for (var i = 0; i < slots.length; i++) {
        if (slots[i].brVolgMaat) slots[i].brVolgMaat(maat);
      }
    }
    window.setTimeout(werkBedragBij, 0);
  });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f !== vorm() || gekozen < 2) return;

    var b = blok();
    var veldId = f.querySelector('[name="id"]');
    /* Geen uitvoering gekozen: dan klaagt het thema er zelf al over. */
    if (!b || !veldId || !veldId.value) return;

    var items = [{ id: veldId.value, quantity: 1 }];
    var slots = b.querySelectorAll('.br-slot');
    for (var i = 0; i < slots.length; i++) {
      var v = slots[i].brVariant && slots[i].brVariant();
      if (!v) {
        e.preventDefault();
        e.stopImmediatePropagation();
        fout('Please choose a color and a size for every item.');
        return;
      }
      items.push({ id: v, quantity: 1 });
    }

    e.preventDefault();
    e.stopImmediatePropagation();
    voegToe(f, items);
  }, true);

  function start() { if (blok()) teken(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Bij een kleurwissel wordt de productsectie opnieuw opgehaald; dan staat er
     een leeg blok en moet dit opnieuw. */
  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(start, 0);
  });
})();
